export default __webpack_public_path__ + "static/media/orto1.408e3d01.jpg";